<template>
  <div v-if="!selectedCompanies.length" class="rm-screen">
    <div class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-domain</v-icon>
      {{ $t("no_companies_selected") }}
    </div>
  </div>
  <report-mobile-shift-rows
    v-else
    :loading="loading"
    :rows="rows"
    :stats="stats"
    :search="filters.search"
    empty-icon="mdi-food-off"
  ></report-mobile-shift-rows>
</template>

<script>
import ReportMealsTabMeals from "@/components/report/more-restaurants/tabs/ReportMealsTabMeals.vue";
import { SHIFTS } from "@/constants/shifts";
import hasShiftBinding from "../../../shared/hasShiftBinding";
import hasShiftSubtitle from "../../../shared/hasShiftSubtitle";
import ReportMobileShiftRows from "../../ReportMobileShiftRows.vue";

/**
 * Mobilni "Obroci" (firme koje hrani restoran): obrok sa ukupnim brojem i brojem po smeni (kupci i restoran
 * zajedno), od najvećeg ka manjem. Firme, smene i period su u zaglavlju, pretraga u lupi. Nasleđuje učitavanje,
 * štampu i Excel iz starog taba.
 */
export default {
  name: "MoreMobileMeals",
  extends: ReportMealsTabMeals,
  mixins: [hasShiftBinding, hasShiftSubtitle],
  components: { ReportMobileShiftRows },
  computed: {
    rows() {
      const named = this.filteredMeals.map((meal) => ({ ...meal, name: this.toLatin(meal.name || "") }));
      const found = this.filters.search ? this.customSearch(named, [{ value: "name" }], this.filters.search) : named;
      const shifts = SHIFTS.filter((shift) => this.selectedShifts.includes(shift.id));
      return found
        .filter((meal) => meal.total > 0)
        .map((meal) => ({
          key: String(meal.id ?? meal.name),
          name: meal.name,
          total: meal.total,
          shifts: shifts.map((shift) => ({ id: shift.id, quantity: meal[shift.key] || 0 })).filter((shift) => shift.quantity > 0),
        }))
        .sort((a, b) => b.total - a.total);
    },
    stats() {
      return [
        { key: "total", label: this.$t("report_desktop.total_meals"), value: this.rows.reduce((sum, row) => sum + row.total, 0) },
        { key: "meals", label: this.$t("meals"), value: this.rows.length },
      ];
    },
  },
};
</script>
